import React, {useRef, useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import {setDocumentIdValue, setShowKeyboard} from "../../actions/global";
import "./Keyboard.scss";
import {useTranslation} from "react-i18next";
const KeyboardComponent = ({country, IsSubmitDisabled, onClick}) => {
  const [layout] = useState("default");
  const keyboard = useRef();
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const {documentIdValue, showKeyboard, storeCountry} = useSelector((state) => {
    return {
      documentIdValue: state.globalReducer?.documentIdValue,
      showKeyboard: state.globalReducer?.showKeyboard,
      storeCountry: state.store?.storeCountry,
    };
  });

  const displayKeys = {
    "{numbers}": "123",
    "{backspace}": "⌫",
    "{abc}": "ABC",
  };
  const layoutType =
    storeCountry == "CL"
      ? {
          default: ["1 2 3", "4 5 6", "7 8 9", "K 0 {backspace}"],
        }
      : {
          default: ["1 2 3", "4 5 6", "7 8 9", " 0 {backspace}"],
        };

  const handleBackspace = () => {
    const newValue = documentIdValue?.slice(0, -1);
    dispatch(setDocumentIdValue(newValue));
  };

  const handleNumbersAndK = (button) => {
    const valueToSet = documentIdValue?.concat(button);
    dispatch(setDocumentIdValue(valueToSet));
  };

  const onKeyPress = (button) => {
    const numberRegex = /^[0-9]+$/;
    if (numberRegex.test(button) || button === "K") {
      handleNumbersAndK(button);
    }
    if (button === "{backspace}") handleBackspace();
  };
  return (
    showKeyboard && (
      <div className="keyboard-component-container">
        <div className="keyboard-done-button-container">
          <button
            className="keyboard-done-button"
            onClick={() => {
              if (!IsSubmitDisabled) {
                onClick();
              }
              dispatch(setShowKeyboard(false));
            }}
          >
            {t("doneKey")}
          </button>
        </div>
        <div className={`${storeCountry === "PE" ? "keyboard-sm" : ""}`}>
          <Keyboard
            keyboardRef={(r) => (keyboard.current = r)}
            layoutName={layout}
            layout={layoutType}
            display={displayKeys}
            maxLength={15}
            onKeyPress={onKeyPress}
          />
        </div>
      </div>
    )
  );
};

export default KeyboardComponent;
